(() => {
  function hydrate() {
    document.querySelectorAll('#RoboCommercialReview').forEach(form => {
      const params = new URLSearchParams(window.location.search);
      form.querySelectorAll('[data-rm-context]').forEach(input => {
        input.value = (params.get(input.dataset.rmContext) || '').slice(0, 240);
      });
      const model = params.get('model');
      const context = form.querySelector('[data-rm-inquiry-context]');
      if (model && context) {
        context.querySelector('[data-rm-inquiry-model]').textContent = model.slice(0, 240);
        context.hidden = false;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate, {once: true});
  else hydrate();
  document.addEventListener('shopify:section:load', hydrate);
})();
